import { IAppConfig } from '../hooks/useEventSubTypeConfig';
const DEFAULT_MENU_ITEMS: IAppConfig[] = [
  {
    appId: 'website',
    label: 'Website',
    route: '/edit/design',
    color: {
      start: 'rgba(82, 146, 241, 1)',
      end: 'rgba(38, 100, 194, 1)',
    },
    description: 'Dsign and customize your event website',
    keywords: ['website', 'design', 'customize', 'event'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/website.png',
    workspaceTile: {
      componentId: 'website',
    },
  },
  {
    label: 'Guest Stays',
    route: '/edit/accommodations',
    color: {
      start: 'rgba(217, 140, 255, 1)',
      end: 'rgba(82, 41, 164, 1)',
    },
    description: 'Simplify guest accommodations while saving them money',
    keywords: ['guest', 'stays', 'accommodations', 'hotels', 'travel'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/stays.png',
  },
  {
    label: 'Contacts',
    route: '/edit/contact',
    color: {
      start: 'rgba(255, 225, 155, 1)',
      end: 'rgba(255, 208, 98, 1)',
    },
    description: 'Collect and manage contacts for your event',
    keywords: ['contact', 'collect', 'manage', 'event', 'guest', 'address', 'email', 'phone'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/contact_collector.png',
  },
  {
    appId: 'event_schedule',
    label: 'Schedule',
    route: '/edit/schedule',
    color: {
      start: 'rgba(255, 225, 155, 1)',
      end: 'rgba(255, 208, 98, 1)',
    },
    description: 'Event schedule to define times and locations for various activities during the event',
    keywords: ['event', 'schedule', 'agenda', 'itinerary', 'times', 'dates', 'locations'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/schedule.png',
    workspaceTile: {
      componentId: 'event_schedule',
      allowScroll: true,
    },
  },
  {
    appId: 'guest_list',
    label: 'Guest List',
    link: '${eventHandle}/edit/guestlist',
    color: {
      start: 'rgba(255, 225, 155, 1)',
      end: 'rgba(255, 208, 98, 1)',
    },
    description: 'Mange the guests attending your event, including RSVPs, dietary restrictions, and more',
    keywords: ['guest', 'list', 'manage', 'rsvp', 'dietary', 'restrictions'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/guest_list.png',
  },
  {
    label: 'Save the Date',
    route: '/edit/cards/wedding/save-the-date',
    color: {
      start: 'rgba(140, 255, 217, 1)',
      end: 'rgba(25, 183, 131, 1)',
    },
    description: 'Create and send a Save the Date for your wedding',
    keywords: [],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/save_the_date.png',
  },
  {
    label: 'Invitation',
    route: '/edit/cards/wedding/invitation',
    color: {
      start: 'rgba(140, 255, 217, 1)',
      end: 'rgba(25, 183, 131, 1)',
    },
    description: 'Design and send invitations for your wedding',
    keywords: ['wedding', 'invitation', 'design', 'send'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/invitations.png',
  },
  {
    label: 'Day of',
    route: '/edit/cards/wedding/menu',
    color: {
      start: 'rgba(140, 255, 217, 1)',
      end: 'rgba(25, 183, 131, 1)',
    },
    description: 'Browse signs, menus, and other stationery for your wedding',
    keywords: ['stationery', 'signs', 'menus', 'wedding'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/stationery.png',
  },
  {
    label: 'RSVP',
    route: '/edit/rsvp2',
    color: {
      start: 'rgba(255, 211, 36, 1)',
      end: 'rgba(255, 211, 36, 1)',
    },
    description: 'Mange your event RSVPs, including guest responses and dietary restrictions',
    keywords: ['rsvp', 'manage', 'guest', 'responses', 'dietary', 'restrictions'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/rsvp.png',
  },
  {
    label: 'Photos',
    route: '/edit/website/photos',
    color: {
      start: 'rgba(255, 173, 137, 1)',
      end: 'rgba(255, 77, 0, 1)',
    },
    description: 'Manage your event photos and albums',
    keywords: ['photos', 'albums', 'gallery', 'images'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/moments.png',
  },
  {
    label: 'Messaging',
    route: '/edit/messaging',
    color: {
      start: 'rgba(138, 255, 152, 1)',
      end: 'rgba(0, 205, 24, 1)',
    },
    description: 'Communicate with your guests through messaging',
    keywords: ['email', 'sms', 'messaging', 'communication', 'guest', 'notify', 'remind'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/messaging.png',
  },
  {
    appId: 'settings',
    label: 'Settings',
    route: '/edit/settings',
    color: {
      start: 'rgba(82, 146, 241, 1)',
      end: 'rgba(38, 100, 194, 1)',
    },
    description: 'Event settings to manage your event details, including title, date, location, and more',
    keywords: ['settings', 'date', 'location', 'configure', 'manage'],
    iconUrl: 'https://withjoy.com/assets/public/proto/modern/website.png',
    workspaceTile: {
      componentId: 'event_countdown',
    },
  },
];

export const appConfiguration = {
  category: 'corporate',
  categorySubType: 'annual_summit',
  title: 'Annual Summit',
  descripion: 'Event template for corporate annual summits.  Contains default 3-day schedule, etc.',
  insights: ['Additional AI friendly descriptors here to help AI have deeper context into what this event type and data structure is about'],
  location: {
    city: 'San Francisco',
    state: 'CA',
    country: 'US',
  },
  date: 'ISO 8601 date with timezone offset here',
  eventImage: 'https://withjoy.com/assets/public/proto/modern/corpor',
  eventIcon: '',
  apps: DEFAULT_MENU_ITEMS,
};
